module.exports = __webpack_public_path__ + "img/attention_icon.f0ded72b.svg";